// extracted by mini-css-extract-plugin
export default {"container":"FreeOrderResult_container__8hB1t","progressContainer":"FreeOrderResult_progressContainer__wd20P"};